module.exports = () => {
    require('datatables');
    let datetimeFormat = require('../../helpers/datetime-format');

    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "date-pt-pre": function (a) {
            if (a == null || a == "" || a.includes("---")) {
                return 0;
            }
            var date = a.split('/');
            var temp = date[2].split(' ');
            var year = temp[0];
            var hour = temp[1].replace('(', '').replace(')', '');
            return new Date(`${year}-${date[1]}-${date[0]} ${hour}`);
        },
        "date-pt-asc": function (a, b) {
            if (a.includes("---")) {
                return 0;
            }
            return ((a < b) ? -1 : ((a > b) ? 1 : 0));
        },
        "date-pt-desc": function (a, b) {
            if (a.includes("---")) {
                return 0;
            }
            return ((a < b) ? 1 : ((a > b) ? -1 : 0));
        }
    });
    $('table.dataTable').dataTable({
        "oLanguage": {
            sSearch: "Pesquisar por:",
            sLengthMenu: "Mostrar &nbsp; _MENU_ &nbsp; registros por página",
            sInfo: "Mostrando de <b>_START_</b> até <b>_END_</b> de um total de <b>_TOTAL_</b> registros",
            sInfoEmpty: "Sem registros para mostrar",
            sZeroRecords: "Nenhum Registro encontrado",
            sInfoFiltered: "(filtrando de _MAX_ registros)",
            oPaginate: { sFirst: "Primeiro", sLast: "Último", sNext: "Próximo", sPrevious: "Anterior" },
        },
        columnDefs: [
            { type: 'date-pt', targets: [8, 9] } //specify your date column number,starting from 0
        ]
    });

    require('jquery-mask-plugin');
    let fillFieldForm = require('../../helpers/fill-fields-form');

    let $inputTelefone = $('input[name="telefone_beneficiario"]');
    $inputTelefone.keyup(function () {
        if ($inputTelefone.val().length === 15) {
            $inputTelefone.mask('(00) 90000-0000');
        } else {
            $inputTelefone.mask('(00) 0000-00000');
        }
    }).trigger('keyup');

    var $inputPlaca = $('input[name="placa"]');
    $inputPlaca.mask('SSS0A00');
    // $inputPlaca.keyup(function () {
    //     $inputPlaca.val($inputPlaca.val().toUpperCase());
    // });

    $('[data-mask-valor]').mask('000.000.000.000.000,00', { reverse: true });

    const $ctx = $('#modalAcionamento form');
    const $inputsValores = $ctx.find(`
        input[name="valor"],
        input[name="valor_indenizacao"],
        input[name="valor_adicional"]
    `);
    function toFloat(val) {
        let temp = val;
        if (temp == '' || !temp) return 0;
        if (typeof val == 'string' && val.includes(',')) {
            temp = temp.replace('.', '');
            temp = temp.replace(',', '.');
        }
        temp = parseFloat(temp);
        temp = parseFloat(temp.toFixed(2));
        return temp;
    }
    $inputsValores.on('keyup', function () {
        let $target = $ctx.find('input[name="custo_total"]');
        let $valor_participacao = $ctx.find('input[name="valor"]');
        let $valor_indenizacao = $ctx.find('input[name="valor_indenizacao"]');
        let $valor_adicional = $ctx.find('input[name="valor_adicional"]');

        $valor_participacao = toFloat($valor_participacao.val() || 0);
        $valor_indenizacao = toFloat($valor_indenizacao.val() || 0);
        $valor_adicional = toFloat($valor_adicional.val() || 0);

        let total = $valor_indenizacao + $valor_adicional;
        total -= $valor_participacao;
        $target.val(parseFloat(total).toFixed(2));
    });

    const $selectStatusSinistro = $ctx.find('select[name="status_sinistro"]');
    $selectStatusSinistro.on('change', function (e) {
        let current_value = $(this).val();
        let classColor = 'warning';
        $ctx.find('.group-situacao-sinistro').hide();
        $ctx.find('.group-empresa-sinistro').hide();

        if (!current_value || current_value == '') {
            return;
        }
        if (current_value == 'Aprovado') {
            $ctx.find('.group-situacao-sinistro').show();
            classColor = 'success'
        }
        if (current_value == 'Negado') {
            classColor = 'danger';
        }
        if (current_value != 'Aprovado' && current_value != 'Negado') {
            $ctx.find('.group-empresa-sinistro').show();
        }

        $(this).removeClass(function (index, className) {
            return (className.match(/(^|\s)text-\S+/g) || []).join(' ');
        });
        $(this).addClass(`text-${classColor}`);
    });


    $('body').on('click', 'table tr [data-table-actions] a[data-action], button.btn[data-action]', function (e) {

        let $this = $(this);
        let $targetModal = $($this.data('target'));
        let $modalTitulo = $targetModal.find('[data-modal-titulo]');
        let $ocultData = $this.closest('[data-table-actions]').find('[data-ocult-data]');

        let arrayCamposTipo = {
            input: {
                data: [
                    'id',
                    'nome_beneficiario',
                    'email_beneficiario',
                    'telefone_beneficiario',
                    'placa',
                    'valor',
                    'valor_indenizacao',
                    'valor_adicional',
                    'custo_total',
                    'data_conclusao',
                    'data_abertura',
                    'protocolo_interno',
                    'empresa_sinistro'
                ],
                attr: {
                    readonly: $this.data('action') != 'novo'
                }
            },
            select: {
                data: [
                    'status_acionamento',
                    'tipo_acionamento',
                    'id_usuario',
                    'situacao_sinistro',
                    'status_sinistro'
                ],
                attr: {
                    readonly: $this.data('action') != 'novo',
                }
            },
            textarea: {
                data: [
                    'observacoes'
                ],
                attr: {
                    readonly: $this.data('action') != 'novo',
                }
            },
            span: {
                data: [
                    'id',
                    'nome_tipo_acionamento',
                    'valor',
                    'nome_beneficiario',
                    'email_beneficiario',
                    'placa',
                    'data_cadastro',
                    'atualizado_em',
                    'arquivo',
                    'data_criacao_semantico',
                    'data_atualizacao_semantico'
                ],
                typeFill: 'html'
            },
            a: {
                data: [
                    'link-arquivo'
                ],
                attr: {
                    currentData: 'href'
                }
            },
            checkbox: {
                data: [
                    'participacao_paga'
                ],
                attr: {
                    disabled: $this.data('action') == 'ver'
                },
            }
        }

        fillFieldForm(arrayCamposTipo, $ocultData, $targetModal);
        $selectStatusSinistro.trigger('change');

        const $checkPago = $ctx.find('input[type="checkbox"][name="participacao_paga"]#participacao_paga');
        const $groupValor = $ctx.find('.group-valor-participacao');
        $checkPago.on('change', function (e) {
            const isChecked = $checkPago.is(':checked');
            const $target = $groupValor.find('>*, span');
            $target.removeClass(function (index, className) {
                return (className.match(/(^|\s)text-\S+/g) || []).join(' ');
            });
            if (isChecked) {
                $target.addClass('text-info');
            }
            else {
                $target.addClass('text-danger');
            }
        });
        $checkPago.trigger('change');

        function handdlerHistoricoObservacoes() {
            $targetModal.find('.novo-observacao').show();
            $targetModal.find('.historico-observacoes').show();
            if ($this.data('action') == 'ver') {
                $targetModal.find('.novo-observacao').hide();
            }

            let historico = JSON.parse($ocultData.find('[name="historico-observacoes"]').val() || []);

            let $historico_container = $targetModal.find('.historico-container');
            $historico_container.html('').removeClass('sem-historico');
            if (!Object.keys(historico).length || historico[0].created_at == null) {
                $historico_container.addClass('sem-historico');
                $historico_container.append(`<h4>Não consta nenhuma observação</h4>`);
                return;
            };
            $.each(historico, (key, item) => {
                let $append = $('<div class="historico-append">');
                let $historico_item = $('<div class="historico-item">');

                let $texto = $(`<div class="texto-observacao"><span>${item.observacao || 'NÂO CONSTA'}</span></div>`)
                    .appendTo($append);

                let $id = $(`<div><b>Responsável ID: ${item.id_usuario || 'NÃO CONSTA'}</b></div>`)
                    .appendTo($historico_item);
                let $data_criacao = $(`<div><b> CRIADO EM: ${datetimeFormat(item.created_at || false)}</b></div>`)
                    .appendTo($historico_item);

                $historico_item.appendTo($append);
                $append.appendTo($historico_container);
            });
        };

        const camposToHide = [
            '.group-status-sinistro',
            '.group-n-protocolo',
            '.group-status-acionamento',
            '.group-valor-indenizacao',
            '.group-valor-adicional',
            '.group-valor-efetivo',
            '.group-arquivo',
        ];
        let camposToEnable = [
            '[name="protocolo_interno"]',
            '[name="observacoes"]',
            '[name="protocolo_interno"]',
            '[name="valor"]',
            '[name="participacao_paga"]',
            '[name="valor_indenizacao"]',
            '[name="valor_adicional"]',
            '[name="empresa_sinistro"]',
            '[name="situacao_sinistro"]',
        ];
        let $status_acionamento = $ctx.find('[name="status_acionamento"]');
        if ($status_acionamento.val() == 4) {
            camposToEnable.push('[name="status_sinistro"]')
        }

        if ($this.data('action') == 'editar') {
            camposToEnable.forEach(element => {
                console.log($ctx.find(`${element}`));
                $ctx.find(`${element}`).prop('readonly', false);
                $ctx.find(`${element}`).attr('readonly', false);
            });
        }

        if ($this.data('action') == 'novo') {
            camposToHide.forEach(element => {
                $ctx.find(element).hide();
            });
        }

        if ($this.data('action') != 'novo') {
            handdlerHistoricoObservacoes();
            camposToHide.forEach(element => {
                $ctx.find(element).show();
            });
        }

        if ($this.data('action') != 'ver')
            $targetModal.find('.btn-success').show();
        else
            $targetModal.find('.btn-success').hide();

        $targetModal.find('input[type="file"]').removeAttr('disabled');
        if ($this.data('action') == 'ver') {
            $targetModal.find('input[type="file"]').attr('disabled', true);
        }

        if ($this.data('action') == 'novo') {
            $targetModal.find('.novo-observacao').show();
            $targetModal.find('.historico-observacoes').hide();
            $targetModal.find('span[name="data_cadastro"]').html('_');
            $targetModal.find('span[name="atualizado_em"]').html('_');
        }

        let tituloAction = 'Visualizando';
        let nomeBeneficiario = $ocultData.find(
            `input[name="nome_beneficiario"]`).val();

        let nomeCliente = $ocultData.find(
            `input[name="nome_usuario"]`).val();

        switch ($this.data('action')) {
            case 'ver':
                tituloAction = `Visualizando acionamento de: <b>${nomeBeneficiario}</b>`;
                break;

            case 'novo':
                tituloAction = 'Criando <b>novo</b> registro.';
                break;

            case 'editar':
                tituloAction = `Visualizando acionamento de: <b>${nomeBeneficiario}</b>`;
                break;

            case 'remover':
                tituloAction = `<b class="text-danger">Você está prestes a remover: ${nomeBeneficiario} | Do cliente: ${nomeCliente}`;
                break;
        }

        $modalTitulo.html(tituloAction);
        $targetModal.modal('show');

        const $modalDialog = $ctx.closest('.modal-dialog');
        const $modalConfirmarParticipacao = $('#modalConfirmarParticipacao');

        $ctx.on('click', '.group-check-valor-participacao ', function (e) {
            const isCheckbox = $(e.target).is('input[type="checkbox"]');
            if (!isCheckbox) {
                return;
            }

            let isChecked = $checkPago.is(':checked');
            isChecked = !isChecked;

            if (!isChecked) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            }

            if (isChecked) {
                $checkPago.prop('checked', false);
                return;
            }

            $modalDialog.animate({ opacity: 0.15 }, 400, function () {
                $modalConfirmarParticipacao.modal('toggle');
            });
        });
        $modalConfirmarParticipacao.find('.modal-footer .btn').on('click', function (e) {
            const $checkPago = $ctx.find('input[type="checkbox"][name="participacao_paga"]');
            $checkPago.prop('checked', true);
            $checkPago.trigger('change');
        });
        $modalConfirmarParticipacao.on('hidden.bs.modal', function (e) {
            $modalDialog.animate({ opacity: 1 });
        });
    });
    let path = window.location.pathname;
    if (path.includes('novo')) {
        $('.btn-novo').trigger('click');
    }
};
